import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import Loading from '../component/loading'
import RequestQueue from '../api/requestQueue'
import config from '../api/config'

function Login() {
    useEffect(() => {
        localStorage.clear()
    }, [])
    const [loading, setLoading] = useState(false)
    const [addData, setAddData] = useState({})
    let navigate = useNavigate()
    const handlerSubmit = (e) => {
        setLoading(true)
        axios
            .post(`${config.getApiBaseUrl()}/session/login`, {
                phone_number: addData.phoneNumber,
                password: addData.password,
            })
            .then((res) => {
                setLoading(false)

                RequestQueue.setAuthResult(res.data)
                localStorage.setItem('authResult', JSON.stringify(res.data))
                navigate('/')
            })
            .catch((error) => {
                setLoading(false)
                toast.error('شماره همراه یا رمز عبور اشتباه است', {
                    position: 'top-right',
                })
            })
    }

    const setQueryPropertyAddData = (key, e) => {
        switch (key) {
            case 'phoneNumber':
                setAddData({ ...addData, phoneNumber: e.target.value })
                break
            case 'password':
                setAddData({ ...addData, password: e.target.value })
                break
            default:
                return null
        }
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handlerSubmit()
        }
    }

    return (
        <>
            {loading ? <Loading /> : null}
            <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
                <div className="relative w-full max-w-md">
                    {/* دایره های دکوراتیو */}
                    <div className="absolute -top-20 -left-20 maxLg:left-0 w-64 h-64 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob"></div>
                    <div className="absolute -bottom-20 -right-20 w-64 h-64 bg-indigo-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>

                    {/* کارت لاگین */}
                    <div className="relative bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl overflow-hidden border border-white border-opacity-30">
                        {/* هدر */}
                        <div className="bg-gradient-to-r from-indigo-600 to-purple-600 py-6 px-8 text-center">
                            <h1 className="text-2xl font-bold text-white flex items-center justify-center">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-8 w-8 ml-2"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                </svg>
                                سامانه مدیریت مرخصی
                            </h1>
                        </div>

                        {/* بدنه فرم */}
                        <div className="p-8">
                            <form className="space-y-6">
                                {/* فیلد شماره همراه */}
                                <div className="space-y-2">
                                    <label className="block text-sm font-medium text-gray-700">
                                        شماره همراه
                                    </label>
                                    <div className="relative">
                                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-5 w-5 text-gray-400"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                                                />
                                            </svg>
                                        </div>
                                        <input
                                            type="tel"
                                            className="w-full pr-10 pl-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                            placeholder="09xxxxxxxxx"
                                            onChange={(e) =>
                                                setQueryPropertyAddData(
                                                    'phoneNumber',
                                                    e
                                                )
                                            }
                                        />
                                    </div>
                                </div>

                                {/* فیلد رمز عبور */}
                                <div className="space-y-2">
                                    <label className="block text-sm font-medium text-gray-700">
                                        رمز عبور
                                    </label>
                                    <div className="relative">
                                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-5 w-5 text-gray-400"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                                                />
                                            </svg>
                                        </div>
                                        <input
                                            type="password"
                                            className="w-full pr-10 pl-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                            placeholder="••••••••"
                                            onChange={(e) =>
                                                setQueryPropertyAddData(
                                                    'password',
                                                    e
                                                )
                                            }
                                            onKeyDown={handleKeyDown}
                                        />
                                    </div>
                                </div>

                                {/* دکمه ورود */}
                                <button
                                    type="button"
                                    onClick={handlerSubmit}
                                    className="w-full py-3 px-4 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-medium rounded-lg shadow-md hover:shadow-lg transition-all duration-300 flex items-center justify-center"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-5 w-5 ml-2"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
                                        />
                                    </svg>
                                    ورود به سیستم
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Login
